<template>
  <div class="page">
    <main-menu-bar/>
    <current-motion-control-panel v-if="hasAccess"/>
    <access-denied-error v-else/>
  </div>
</template>

<script>
import CurrentMotionControlPanel from '../control/CurrentMotionControlPanel.vue'
import MainMenuBar from '../nav/MainMenuBar.vue'
import AccessDeniedError from '../errors/AccessDeniedError.vue'
import Role from '../../enums/role'
export default {
  name: 'CurrentMotionControlPanelPage',
  components: {
    CurrentMotionControlPanel,
    MainMenuBar,
    AccessDeniedError
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      // console.log('route enter')
      // console.log(vm.$store.getters['auth/user'])
    })
  },
  computed: {
    hasAccess () {
      if (!this.$store.getters['auth/authenticated']) {
        return false
      }
      return this.$store.getters['auth/user'].hasRole(
        [
          Role.OPERATOR,
          Role.ADMIN
        ]
      )
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/CurrentMotionControlPanelPage.vue